import { render, staticRenderFns } from "./BuscadorOperacionCrud.vue?vue&type=template&id=3e52b121&"
import script from "./BuscadorOperacionCrud.vue?vue&type=script&lang=ts&"
export * from "./BuscadorOperacionCrud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports